module.exports = __webpack_public_path__ + "static/media/PSLDisplayPro.a01e8662.woff2";